var contentSlider = document.querySelectorAll(
  ".wp-block-fseblocks-content-slider .content-swiper"
);

for (i = 0; i < contentSlider.length; i++) {
  contentSlider[i].classList.add("slide-" + i);

  const isClickable = jQuery(".content-swiper.slide-" + i).data("clickable");
  const isAutoPlay = jQuery(".content-swiper.slide-" + i).data("auto");
  const speed = jQuery(".content-swiper.slide-" + i).data("speed");
  const perView = jQuery(".content-swiper.slide-" + i).data("perview");
  const space = jQuery(".content-swiper.slide-" + i).data("space");
  const loop = jQuery(".content-swiper.slide-" + i).data("loop");
  const smallPerView = jQuery(".content-swiper.slide-" + i).data(
    "smallperview"
  );
  const smallspace = jQuery(".content-swiper.slide-" + i).data("smallspace");
  const mediumPerView = jQuery(".content-swiper.slide-" + i).data(
    "mediumperview"
  );
  const mediumspace = jQuery(".content-swiper.slide-" + i).data("mediumspace");
  const effect = jQuery(".content-swiper.slide-" + i).data("effect");
  const autocentre = jQuery(".content-swiper.slide-" + i).data("autocentre");
  const autoslidesperview = jQuery(".content-swiper.slide-" + i).data(
    "autoslidesperview"
  );
  const initialSlide = jQuery(".content-swiper.slide-" + i).data(
    "initialslide"
  );

  var swiperOptions = {
    loop: loop,
    initialSlide: initialSlide,
    loopedSlides: autoslidesperview ? 2 : 0,
    effect: effect,
    //speed: 800,
    //freeMode: true,
    //loadOnTransitionStart: true, // test
    //loadPrevNext: true, // test
    centeredSlides: autocentre,
    spaceBetween: perView === 1 ? 0 : smallspace,
    slidesPerView: autoslidesperview == true ? "auto" : smallPerView,

    autoplay:
      isAutoPlay === true
        ? {
            delay: parseInt(speed * 1000),
          }
        : false,
    pagination: {
      el: `.content-swiper.slide-${i} .swiper-pagination`,
      clickable: isClickable,
    },
    navigation: {
      nextEl: `.content-swiper.slide-${i} + .fseblocks-swiper-nav .swiper-button-next`,
      prevEl: `.content-swiper.slide-${i} + .fseblocks-swiper-nav .swiper-button-prev`,
    },
    breakpoints: {
      640: {
        slidesPerView: autoslidesperview
          ? "auto"
          : smallPerView !== undefined
          ? smallPerView
          : 1,

        //slidesPerView: smallPerView ? smallPerView : 1,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: autoslidesperview
          ? "auto"
          : mediumPerView !== undefined
          ? mediumPerView
          : 3,

        //slidesPerView: mediumPerView ? mediumPerView : 3,
        spaceBetween: mediumPerView === 1 ? 0 : mediumspace,
      },
      // 1280: {
      //   slidesPerView:
      //     perView !== undefined ? perView : autoslidesperview ? "auto" : 5,
      //   //slidesPerView: perView ? perView : 5,
      //   spaceBetween: perView === 1 ? 0 : space,
      // },
      1280: {
        slidesPerView: autoslidesperview
          ? "auto"
          : perView !== undefined
          ? perView
          : 5,
        spaceBetween: perView === 1 ? 0 : space,
      },
    },
  };

  // Conditionally add fadeEffect property if effect is 'fade'
  if (effect === "fade") {
    swiperOptions.fadeEffect = { crossFade: true };
  }

  var swiper = new Swiper(".content-swiper.slide-" + i, swiperOptions);
}
